
import React, {Component} from 'react'
import {Modal, ModalBody, Button, Card, CardHeader} from 'reactstrap';
import CdnImage from '../../../components/cdnImage/cdnImage'
import Rating from '../../../components/rating/rating';
import SaleDetailView from "../../../components/sale/SaleDetailView";
import InputTextComponent from "../../../components/forms/InputTextComponent";
import HeaderComponent from "../../../components/header/HeaderComponent";
import { BiSearch } from "react-icons/bi";

var stateManager = require('../../../utils/state/stateManager.js');
var screenKeyboardAction = require('../../../utils/state/actions/views/onScreenKeyboard/screenKeyboardAction');
var navigationPageAction = require('../../../utils/state/actions/views/navigationPage/navigationPageAction.js');
const translator = require('../../../utils/translator/translator');
const dateUtil = require('../../../utils/dateUtil/dateUtil');
const logger = require('../../../utils/logger/logger');
const stringUtil = require('../../../utils/string/stringUtil');
var configurationManager = require('../../../utils/config/configurationManager.js');
const themeUtil = require('../../../utils/view/themeUtil.js');

class CLILogs extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.searchText = "";

        this.state.selectedSale = null;
    }

    render()
    {

        return <div className='h-100'>
                    <div style={{fontWeight:'normal'}}>
                        {this.renderToolbar()}
                    </div>
                    <div className='h-100 flex-grow-1' style={{padding:'10px', paddingTop:'15px', overflowY:'auto'}}>
                        {this.renderBody()}
                        {this.renderSaleDetailModalDialogue()}
                    </div>
               </div>
    }

    renderToolbar()
    {
        return <HeaderComponent title={translator.getLabel("callLogs")}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'99%', whiteSpace:'nowrap'}}>
                                <div style={{marginRight:'10px'}}>

                                    <InputTextComponent style={{height:'var(--button-height)'}} placeholder={
                                           <span>
                                                <BiSearch /> {translator.getLabel("search")}
                                           </span>
                                    } 
                                                        value={this.state.searchText}
                                                        inputTextType="text"
                                                        onValueChange={(value)=>
                                                            {
                                                                this.state.searchText = value;
                                                                this.setState({});
                                                            }}/>
                                </div>
                            </td>

                            <td style={{whiteSpace:'nowrap'}}>
                                <div style={{minWidth:'10vw'}}>
                                    <Button block className='btn-cancel'
                                        onClick={()=>
                                            {
                                                logger.usage("SalesView.Exit", "Staff clicked exit button to exit");
                                                this.state.unmounted = true;
                                                stateManager.getStore().dispatch(screenKeyboardAction.createAction(null));
                                                stateManager.getStore().dispatch(navigationPageAction.createAction(null))
                                            }}>{translator.getLabel("exit")}</Button>
                                </div>
                            </td>
                        </tr>
                </table>
            </HeaderComponent>
    }

    renderBody()
    {
        let components = [];

        stateManager.getStore().getState().cliLogs.forEach (cliResult =>
        {
            if (this.isMatching(cliResult))
                components.push(this.renderCLICall(cliResult));    
        })

        if (components.length <= 0)
        {
            components.push(<div className='caption primary-color d-flex flex-column justify-content-center align-items-center' style={{marginTop:'20vh'}}>
                                    <div>
                                        {translator.getLabel("no_calls_found")}   
                                    </div>                            
                            </div>)
        }
        

        return <div style={{height:'87vh', overflowY:'auto'}}>
                    {components}
                </div>
    }

    renderCLICall(cliResult)
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;

        return <Card style={{marginBottom:'20px', border:'1px solid #787878'}}>
                    <CardHeader style={{background:'#FFFFFF'}}>
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{whiteSpace:'nowrap', borderRight:'1px solid #C8C8C8', verticalAlign:'center'}}>
                                        <div style={{marginTop:'10px', marginRight:'15px'}}>
                                            <div>
                                                <CdnImage cloudName={cloudName} width="35" height="35" publicId={themeUtil.getPublicId("phone.ring.png")}/>
                                            </div>
                                            <div style={{marginTop:'5px'}}>
                                                <h3>{cliResult.cliIncomingNumber}</h3>
                                            </div>
                                            <div style={{textAlign:'center'}}>
                                                {translator.getLabel("time")}: {dateUtil.formatDate (cliResult.dateTime, "HH:mm")}
                                            </div>
                                        </div>
                                </td>
                                <td style={{width:'99%', verticalAlign:'center'}}>
                                    {this.renderCustomerDetails(cliResult)}
                                </td>
                            </tr>
                        </table>
                        
                    </CardHeader>
               </Card>
    }

    renderCustomerDetails(cliResult)
    {
        if (cliResult == null || cliResult.customer == null)
        {
            return (<div style={{marginLeft:'20px', marginTop:'10px'}}>
                        {translator.getLabel("no_customer_record_found")}
                    </div>)
        }

        const customer = cliResult.customer;
        const rating = customer.profile ? customer.profile.rating : null;
        const allOrderCount = stringUtil.isStringNullOrEmpty(cliResult.orderCount) ? 0 : cliResult.orderCount;
        const sale = this.getOrderNumber(customer);

        let saleComponent = null;
        if (sale != null)
            saleComponent = <Button className='btn-action' style={{marginTop:'20px', marginBottom:'10px'}}
                                    onClick={()=>
                                    {
                                        logger.usage("CLILogs.Sale", "Staff click button to open sale window")
                                        this.state.selectedSale = sale;
                                        this.setState({});
                                    }}>
                                
                                {sale.number}
                            </Button>

        return <div style={{marginLeft:'20px', marginTop:'10px'}}>
                    <div>
                        <div>
                            <div>
                                <table>
                                    <tr>
                                        <td>
                                            <h3>{customer.name}</h3>
                                        </td>
                                        <td>
                                            <div style={{marginLeft:'5px', marginTop:'-10px'}}><Rating rating={rating}></Rating></div>
                                        </td>
                                    </tr>
                                </table>
                                <div>{translator.getLabel("no_of_past_orders")}: {allOrderCount}</div>
                            </div>
                            {saleComponent}
                        </div>
                        
                        
                    </div>
                </div>
    }

    getOrderNumber(customer)
    {
        let todaysSales = stateManager.getStore().getState().todaySales;
        return todaysSales.find(s => stringUtil.areStringSame(s.customerId, customer.id));
    }

    isMatching(cliResult)
    {
        if (stringUtil.isStringNullOrEmpty(this.state.searchText))
            return true;

        if (cliResult.cliIncomingNumber.includes(this.state.searchText))
            return true;

        if (cliResult == null || cliResult.customer == null)
            return false;

        const customer = cliResult.customer; 
        if (customer.name.toLowerCase().includes(this.state.searchText.toLowerCase()))
            return true;

        if (customer.phoneNumber.includes(this.state.searchText))
            return true;

        return false;
    }

    renderSaleDetailModalDialogue()
    {
        if (this.state.selectedSale == null)
            return;

        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'30vw', maxWidth:'30vw'}}
                        toggle={()=>
                                {
                                    this.state.selectedSale = null;
                                    this.setState({});
                                }} >
                    <ModalBody>
                        <div>
                            <div style={{height:'80vh', overflowY:'auto'}}>
                                <SaleDetailView sale={this.state.selectedSale}
                                                onDispatch={()=>
                                                {
                                                    this.state.selectedSale = null;
                                                    this.setState({});
                                                }}/>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>);
    }
}

export default CLILogs